export const whatsNew_FlexPane_Title = "a84Gfd";
export default {whatsNew_FlexPane_Title};